document.addEventListener('click',function(e){
  var button=e.target.closest('[data-burger]');
  var nav=document.querySelector('[data-nav]');
  if(!nav)return;
  if(button){
    var opened=nav.classList.toggle('open');
    button.setAttribute('aria-expanded',opened?'true':'false');
    button.setAttribute('aria-label',opened?'Zamknij menu':'Otwórz menu');
    var icon=button.querySelector('span');
    if(icon)icon.textContent=opened?'×':'☰';
    return;
  }
  if(nav.classList.contains('open')&&!e.target.closest('[data-nav]'))closeMenu(nav);
});
document.addEventListener('click',function(e){
  if(e.target.closest('[data-nav] a')){
    var nav=document.querySelector('[data-nav]');
    if(nav)closeMenu(nav);
  }
});
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'){
    var nav=document.querySelector('[data-nav]');
    if(nav)closeMenu(nav);
  }
});
function closeMenu(nav){
  nav.classList.remove('open');
  var button=document.querySelector('[data-burger]');
  if(button){
    button.setAttribute('aria-expanded','false');
    button.setAttribute('aria-label','Otwórz menu');
    var icon=button.querySelector('span');
    if(icon)icon.textContent='☰';
  }
}
